"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require("react-intl");

var _components2 = require("components");

var _forms = require("metadata/forms");

var _pacomo = require("utils/pacomo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    BedInput: {
        displayName: "BedInput"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/BedInput.js",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var bedTypes = {
    twinBed: require("theme/img/bed_types/twin.svg"),
    doubleBed: require("theme/img/bed_types/double.svg")
};

var IconsByCode = function IconsByCode(_ref) {
    var code = _ref.code;

    if (code === _forms.formOptions.bedTypeValues[1]) {
        return _react3.default.createElement("img", { src: bedTypes.twinBed, width: "25px" });
    } else if (code === _forms.formOptions.bedTypeValues[2]) {
        return _react3.default.createElement("img", { src: bedTypes.doubleBed, width: "25px" });
    }
};

var BedInput = _wrapComponent("BedInput")((0, _reactIntl.injectIntl)(_class = (0, _pacomo.pacomoDecorator)(_class = function (_React$Component) {
    (0, _inherits3.default)(BedInput, _React$Component);

    function BedInput() {
        (0, _classCallCheck3.default)(this, BedInput);
        return (0, _possibleConstructorReturn3.default)(this, (BedInput.__proto__ || (0, _getPrototypeOf2.default)(BedInput)).apply(this, arguments));
    }

    (0, _createClass3.default)(BedInput, [{
        key: "updateInput",

        // Updates the underlying Input with a new value
        // value = "Twin" | "Matrimonial"
        value: function updateInput(value) {
            if (value) {
                return this.props.input.onChange({
                    name: value
                });
            } // else
            return null;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                input = _props.input,
                intl = _props.intl,
                helpText = _props.helpText,
                _props$meta = _props.meta,
                touched = _props$meta.touched,
                error = _props$meta.error;

            // bedTypeValues = { 1: "Twin", 2: "Matrimonial", ... }

            var inputs = (0, _keys2.default)(_forms.formOptions.bedTypeValues).map(function (key) {
                return _react3.default.createElement(
                    "div",
                    {
                        onClick: function onClick() {
                            if (_forms.formOptions.bedTypeValues[key]) {
                                _this2.updateInput(_forms.formOptions.bedTypeValues[key]);
                            }
                        },
                        className: "input-container " + (input.value.name === _forms.formOptions.bedTypeValues[key] ? "input-selected" : ""),
                        key: key
                    },
                    _react3.default.createElement(
                        "div",
                        { className: "label" },
                        _react3.default.createElement(
                            "h3",
                            null,
                            intl.formatMessage(_forms.formOptions.bedTypeLabels[key])
                        ),
                        _react3.default.createElement(
                            "p",
                            null,
                            intl.formatMessage(_forms.formOptions.bedTypeDescriptions[key])
                        )
                    ),
                    _react3.default.createElement(
                        "div",
                        { className: "icon" },
                        _react3.default.createElement(IconsByCode, { code: _forms.formOptions.bedTypeValues[key] })
                    )
                );
            });

            return _react3.default.createElement(
                "div",
                null,
                _react3.default.createElement(_components2.FieldHelpErrorText, {
                    touched: touched,
                    error: error,
                    helpText: helpText
                }),
                _react3.default.createElement(
                    "div",
                    { className: "inputs" },
                    inputs
                )
            );
        }
    }]);
    return BedInput;
}(_react3.default.Component)) || _class) || _class);

exports.default = BedInput;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/BedInput.js
// module id = 631
// module chunks = 0